<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Exception Report</strong> 

          </div>
          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
              <li class="nav-item">
                <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Not Assigned</a>
              </li>
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Assigned</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">OFD</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" >Handover Pending</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 4"  class="nav-link " :class="{'active' : isActiveTab(4)}">RTO</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 5"  class="nav-link" :class="{'active' : isActiveTab(5)}" >Delivered</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 6"  class="nav-link" :class="{'active' : isActiveTab(6)}" >PickCancel </a>
              </li>
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
        
            <div class="tab-panel" v-if="isActiveTab(0)">
              <NotAssigned_mr style="width:70%;"></NotAssigned_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(1)">
            <Assigned_mr style="width:70%;"></Assigned_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <Ofd_mr style="width:70%;"></Ofd_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(3)">
            <ndr_mr width=70% ></ndr_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(4)">
            <rto_mr width=70% ></rto_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(5)">
                <delivered_mr width=70% ></delivered_mr>
            </div>
              <div class="tab-panel" v-if="isActiveTab(6)">
                <pickCancel_mr width=70% ></pickCancel_mr>
            </div>
            <documents v-if="isActiveTab(3)"></documents>
             </b-col>
          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   

</notassigned-component>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import NotAssigned_mr from './notAssigned_mr.vue'
import PickCancel_mr from './pickCancel_mr.vue'
import Assigned_mr from './assigned_mr.vue'
import Ofd_mr from './ofd_mr.vue'
import delivered_mr from './delivered_mr.vue'
import rto_mr from './rto_mr.vue'
import ndr_mr from './ndr_mr.vue'

export default {
  data: function() {
    return {
      activeTab: 0,
      NotAssigned_mr,
      PickCancel_mr,
      Assigned_mr,
      Ofd_mr,
      id:'',
      delivered_mr,
      rto_mr,
      ndr_mr,
      name: 'exceptionReport_mr'
    };
  },
  components: {
    NotAssigned_mr,
    PickCancel_mr,
    Assigned_mr,
    Ofd_mr,
    delivered_mr,
    rto_mr,
    ndr_mr
  },
  created: function() {
    this.isActiveTab(0);
  },
  methods: {
  	isActiveTab(id)
    {
       return this.activeTab === id
    }
  }
};
</script>
